import React from 'react';

import ListGroup from '../../Components/ListGroup';
import CourseCard from '../../Components/CourseCard';

import './style.css';

const Courses = ({ onCourseClick, courses = [] }) => {
  return (
    <ListGroup title="Learn more about the courses" count={3}>
      {courses && courses.length > 0
        ? courses.map((course, index) => (
            <CourseCard
              position={index}
              onCourseClick={onCourseClick}
              key={course.id}
              {...course}
            />
          ))
        : null}
    </ListGroup>
  );
};
export default Courses;



// WEBPACK FOOTER //
// ./src/Pages/LiveClasses/Courses.js